import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Gateway, GatewayAdapter } from "src/app/core/models/gateway.model";
import { HydraoApiService } from "src/app/core/services/core/hydrao-api.service";

@Injectable({
  providedIn: "root",
})
export class GatewayService extends HydraoApiService<Gateway> {
  private _gatewayAdapter: GatewayAdapter = inject(GatewayAdapter);

  public getGateways(): Observable<Gateway[]> {
    const url = "/my-gateways";
    return this.get(url, this._gatewayAdapter);
  }

  public getGatewaysForStore(): Observable<Gateway[]> {
    const url = "/my-gateways";
    return this.get(url, this._gatewayAdapter, true, true);
  }
}
